import React from "react";
import ContactFrom from "../components/ContactUs/ContactFrom";
import OurClinic from "../components/ContactUs/OurClinic";

const ContactUs = () => {
  return (
    <>
      <section className=" w-full  md:px-[75px] px-[24px] md:pt-[210px] pt-[124px]">
        <ContactFrom />
        <OurClinic />
      </section>
    </>
  );
};

export default ContactUs;
